import { createPortal } from 'react-dom'
import React from 'react'
import UserFeedback from '../index'

interface Params {
  id: string;
}

export default function UserFeedbackPortal({ id }: Params) {
  const Root = document.getElementById(id);

  if (!Root) {
    return null
  }

  const category = Root.getAttribute('data-category');
  const userId = Root.getAttribute('data-userId');

  if (!category || !userId) {

    throw new Error('"data-category" and "date-userId" attributes is required')
  }

  return createPortal(<UserFeedback category={category} userId={parseInt(userId, 10)} />, Root)
}
